export const WORKS_MAX_LIMIT: number = 50;
